// Import model
import { FilterBomKitItemRequest } from '../models/FilterBomKitItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { BomKitItemCondition } from '../models/BomKitItemCondition';
import { BomKitItemFields } from '../models/BomKitItemFields';
import { BomKitItemIndexedFields } from '../models/BomKitItemIndexedFields';

// Import dependency serializers (for complex types)
import { BomKitItemConditionSerializer } from './BomKitItemConditionSerializer';
import { BomKitItemFieldsSerializer } from './BomKitItemFieldsSerializer';
import { BomKitItemIndexedFieldsSerializer } from './BomKitItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterBomKitItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterBomKitItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterBomKitItemRequest instance
   */
  static deserialize(json: string): FilterBomKitItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterBomKitItemRequest instance
   */
  static fromObject(obj: any): FilterBomKitItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterBomKitItemRequest');
    }


    const instance: FilterBomKitItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as BomKitItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as BomKitItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        BomKitItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterBomKitItemRequest instances
   */
  static deserializeArray(json: string): FilterBomKitItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterBomKitItemRequest instance to a JSON string
   */
  static serialize(instance: FilterBomKitItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterBomKitItemRequest instance to a plain object
   */
  static toObject(instance: FilterBomKitItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        BomKitItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterBomKitItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterBomKitItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
